import React, { useState } from "react";
import "./assetCategorization.css";
import axios from "axios";
import { Link } from "react-router-dom";
import Select from "react-select";
import { DEPARTMENTS } from "../../Data/department";

/* ------------------ helpers ------------------ */
const toOptions = (arr) => arr.map((v) => ({ label: v, value: v }));

/* ------------------ component ------------------ */
const Categorization = () => {
  const [category, setCategory] = useState({
    label: "",
    value: "",
  });

  const [types, setTypes] = useState("");
  const [customType, setCustomType] = useState("");
  const [subComponent, setSubComponent] = useState("");
  const [customSubComponent, setCustomSubComponent] = useState("");
  const [department, setDepartment] = useState([]);

  /* ---------- Category Options ---------- */
  const categories = [
    { label: "Furniture, Fixtures & Office Equipment (FF&E)", value: "FF&E" },
    { label: "IT & Communication Equipment", value: "IT" },
    { label: "Electrical & Electronics", value: "Electrical" },
    { label: "Machinery & Plant", value: "Machinery" },
    { label: "HVAC (Heating, Ventilation & Air Conditioning)", value: "HVAC" },
    { label: "Kitchen, Bakery & F&B Equipment", value: "Kitchen" },
    { label: "Housekeeping & Laundry Equipment", value: "Housekeeping" },
    { label: "Safety, Security & Fire Protection", value: "Safety" },
    { label: "Vehicles & Transport", value: "Vehicles" },
    { label: "Tools & Maintenance Assets", value: "Tools" },
    { label: "Recreation, Sports & Guest Experience", value: "Recreation" },
    { label: "Agriculture, Landscaping & Outdoor", value: "Agriculture" },
    { label: "PPE Items", value: "PPE" },
    {label: "Accommodation Assets", value: "Accommodation"},
    {
      label: "Inventory-Type Assets (Trackable / High Value)",
      value: "Inventory",
    },
  ];

  /* ---------- Types by Category ---------- */
  const getTypesByCategory = (category) => {
    switch (category) {
      case "FF&E":
        return [
          "Tables, Chairs, Cupboards",
          "Guest Room Furniture",
          "Restaurant / Bar Furniture",
          "Outdoor Furniture",
          "Curtains / Blinds / Upholstery",
          "Safes / Lockers",
          "Signage / Name Boards",
          "Other",
        ];

      case "IT":
        return [
          "Desktop Computers",
          "Laptops",
          "Storage Devices",
          "Printers / Scanners / Copiers",
          "Network Equipment",
          "CCTV System",
          "Telephones / PABX / Intercom",
          "Tablets / Mobile Devices",
          "UPS",
          "Other",
        ];

      case "Electrical":
        return [
          "TVs / Display Units",
          "Sound Systems / Speakers",
          "UPS / Stabilizers",
          "Electrical Panels / DB Boards",
          "Wiring & Cabling",
          "Lighting Systems (Indoor / Outdoor)",
          "Generators",
          "Solar System Components",
          "Other",
        ];

      case "Machinery":
        return [
          "Boilers / Hot Water Systems",
          "Water Pumps / Motors",
          "Compressors",
          "Workshop Machinery",
          "Water Treatment / Filtration Units",
          "Sewage Treatment Plant (STP) Equipment",
          "Laundry Plant Equipment (Industrial)",
          "Other",
        ];
      case "PPE":
        return [
          "Karabinar",
          "Harness",
          "Trolley",
          "Helmet",
          "Joko Lanyards",
          "Connect Adjust",
          "Ascension",
          "Partner Pully",
          "Id S",
          "Podium",
          "Knife",
          "Rope",
          "Springs",
          "Reductions",
          "Dropes",
          "Swivels",
          "Rope Brush",
          "Grillon",
          "Absorbica Y",
          "Jane-Y",
          "Ziippy Spesar",
          "Ziippy E Clips",
          "Speedgun",
          "Cabloc",
          "Wire Anchor Strop",
          "Foot Loop",
          "Rope Identification Kit",
          "Grigri",
          "Sling",
          "Hoister",
          "Bucket",
          "Fall Arrester",
          "Asap Sorber",
          "Rigging Plate",
          "Breakpad",
          "Brake Trolley",
          "Bungee Cord",
          "Vizr Shadow",
          "Tool Bag",
          "Other",
        ];

      case "HVAC":
        return [
          "Air Conditioners (Split / Central)",
          "Ventilation Fans / Exhaust Systems",
          "Chillers / Cooling Units",
          "Cold Room Units",
          "Other",
        ];

      case "Kitchen":
        return [
          "Cooking Ranges / Ovens",
          "Refrigerators / Chillers",
          "Freezers",
          "Dishwashers",
          "Food Preparation Equipment",
          "Coffee Machines / Grinders",
          "Ice Machines",
          "Buffet Equipment",
          "Plate Warmers",
          "Gas Systems",
          "Other",
        ];

      case "Housekeeping":
        return [
          "Vacuum Cleaners",
          "Floor Scrubbers / Polishers",
          "Steam Cleaners",
          "Trolleys (HK / Linen)",
          "Washing Machines / Dryers",
          "Ironing Equipment",
          "Other",
        ];
        case "Accommodation":
        return [
          "Beds & Mattresses",
          "Tables",
          "Chairs",
          "Fans",
          "Electrical Items",
          "Mini Fridges",
          "Other",
        ];

      case "Safety":
        return [
          "Fire Extinguishers",
          "Fire Alarm System",
          "Smoke / Heat Detectors",
          "Emergency Lights / Exit Signs",
          "Fire Hydrant System",
          "Safety Sign Boards",
          "Access Control Systems",
          "Other",
        ];

      case "Vehicles":
        return [
          "Cars",
          "Vans",
          "Buses",
          "Motorbikes",
          "Forklifts / Utility Vehicles",
          "Trailers",
          "Other",
        ];

      case "Tools":
        return [
          "Hand Tools",
          "Power Tools",
          "Ladders / Scaffolding",
          "Welding Equipment",
          "Plumbing Tools",
          "Electrical Tools",
          "Other",
        ];

      case "Recreation":
        return [
          "Swimming Pool Equipment",
          "Gym Equipment",
          "Spa Equipment",
          "Other",
        ];

      case "Agriculture":
        return [
          "Garden Tools & Equipment",
          "Irrigation Systems",
          "Outdoor Lighting",
          "Other",
        ];

      case "Inventory":
        return [
          "Linens",
          "Uniforms",
          "Crockery / Cutlery",
          "Tablecloths",
          "Napkins",
          "Other",
        ];

      default:
        return [];
    }
  };

  /* ---------- ICT Sub-Components ---------- */
  const getICTSubComponents = (type) => {
    switch (type) {
      case "Desktop Computers":
        return [
          "Full Set",
          "CPU",
          "Monitor",
          "Keyboard",
          "Mouse",
          "Ram",
          "Hard Drive",
          "Power Supply",
          "SSD",
          "Add New",
        ];

      case "Storage Devices":
        return ["Pen Drive", "Portable Hard Drive", "Memory Card", "Add New"];

      case "Network Equipment":
        return ["Router", "Switch", "Access Point", "Add New"];
      case "CCTV System":
        return ["Camera", "NVR / DVR", "Add New"];

      default:
        return [];
    }
  };

  const typesList = getTypesByCategory(category.value);
  const isICT = category.value === "IT";
  const subComponentList = isICT ? getICTSubComponents(types) : [];

  /* ---------- Submit ---------- */
  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      category: category.label,
      types: types === "Other" ? customType : types,
      subComponent:
        subComponent === "Add New" ? customSubComponent : subComponent || null,

      departments: department.map((d) => d.value), // ✅ multiple departments
    };

    try {
      const res = await axios.post(
        "/api/categories",
        /*  "/api/categories",*/

        payload,
      );
      alert(res.data.message || "Category Created");
      setCategory({ label: "", value: "" });

      setTypes("");
      setCustomType("");
      setSubComponent("");
      setCustomSubComponent("");
      setDepartment([]);
    } catch (error) {
      alert("Error creating category");
    }
  };

  /* ---------- UI ---------- */
  return (
    <div className="body">
      <div className="asset-categorization">
        <div className="form-container">
          <h2 className="catergoryhead">Asset Categorization</h2>

          <p>
            <Link to="/AdminDashboardPage">Dashboard</Link>
          </p>

          <form onSubmit={handleSubmit}>
            <div className="input-box">
              {/* Category */}
              <Select
                placeholder="Select Category"
                options={categories}
                value={category.value ? category : null}
                onChange={(opt) => {
                  setCategory(opt || { label: "", value: "" });
                  setTypes("");
                  setSubComponent("");
                  setCustomType("");
                }}
                isClearable
              />

              {/* Type */}
              {category.value && (
                <Select
                  placeholder="Select Type"
                  options={toOptions(typesList)}
                  value={types ? { label: types, value: types } : null}
                  onChange={(opt) => {
                    setTypes(opt?.value || "");
                    setSubComponent("");
                    setCustomType("");
                  }}
                  isClearable
                />
              )}

              {/* Custom Type */}
              {types === "Other" && (
                <input
                  type="text"
                  placeholder="Enter Custom Type"
                  value={customType}
                  onChange={(e) => setCustomType(e.target.value)}
                />
              )}

              {/* ICT Sub-Component */}

              {isICT && subComponentList.length > 0 && (
                <Select
                  placeholder="Select Sub Component"
                  options={toOptions(subComponentList)}
                  value={
                    subComponent
                      ? { label: subComponent, value: subComponent }
                      : null
                  }
                  onChange={(opt) => {
                    setSubComponent(opt?.value || "");
                    setCustomSubComponent(""); // reset custom input
                  }}
                  isClearable
                />
              )}

              {subComponent === "Add New" && (
                <input
                  type="text"
                  placeholder="Enter Custom Sub Component"
                  value={customSubComponent}
                  onChange={(e) => setCustomSubComponent(e.target.value)}
                />
              )}

              {/* Department (Multi Select) */}
              <Select
                placeholder="Select Register Access Departments"
                options={DEPARTMENTS}
                value={department}
                onChange={(opts) => setDepartment(opts || [])}
                isMulti
                closeMenuOnSelect={false}
                isClearable
              />
            </div>

            <button type="submit" className="create-category-btn">
              Create Category
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Categorization;
